import React, { useState } from "react";
import { FiPlay, FiX } from "react-icons/fi";
import homeBanner3 from "../../image/home_banner/Homebanner.webp";
import campusVideo from "../../video/Visit.mp4";
import "./Landing.css";

function Landing({ video, cover }) {
  const [videoOpen, setVideoOpen] = useState(false);

  return video ? (
    <>
      <section className="landing-hero" aria-labelledby="landing-hero-title">
        <img
          className="landing-hero-image"
          src={homeBanner3}
          alt="HGS Bhimtal students enjoying time together on campus"
        />
        <div className="landing-hero-wash" aria-hidden="true" />

        <div className="landing-hero-container">
          <div className="landing-hero-copy">
            <p className="landing-hero-eyebrow">HGS, Bhimtal</p>
            <h1 id="landing-hero-title">
              Every Child.
              <br />
              Every Opportunity.
              <br />
              Every Day.
            </h1>
            <span className="landing-hero-title-line" aria-hidden="true" />
            <p className="landing-hero-description">
              Empowering children to become confident, compassionate and
              capable leaders of tomorrow.
            </p>

            <div className="landing-hero-actions">
              <button
                className="landing-hero-video"
                type="button"
                onClick={() => setVideoOpen(true)}
              >
                <span className="landing-hero-play">
                  <FiPlay aria-hidden="true" />
                </span>
                Watch Video
              </button>
            </div>
          </div>
        </div>
      </section>

      {videoOpen && (
        <div
          className="landing-video-modal"
          role="dialog"
          aria-modal="true"
          aria-label="HGS Bhimtal campus video"
          onMouseDown={(event) => {
            if (event.currentTarget === event.target) setVideoOpen(false);
          }}
        >
          <div className="landing-video-dialog">
            <button
              className="landing-video-close"
              type="button"
              aria-label="Close video"
              onClick={() => setVideoOpen(false)}
            >
              <FiX aria-hidden="true" />
            </button>
            <video src={campusVideo} controls autoPlay playsInline>
              Your browser does not support HTML video.
            </video>
          </div>
        </div>
      )}
    </>
  ) : (
    <div className="cover_img_cont">
      <img src={cover} alt="" className="cover_img" />
    </div>
  );
}

export default Landing;
